export default function DeleteModal({ handleDelete, setDeleteStatus }) {
  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50  mx-auto">
        <div className="bg-white border p-6 text-center shadow-lg rounded-lg md:max-w-xl md:w-1/2">
          <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
            Are you sure you want to delete this cobrander?
          </h3>
          <div className="flex justify-center space-x-4">
            <button
              onClick={() => {
                handleDelete();
                setDeleteStatus(false);
              }}
              type="button"
              className="inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-white bg-rose-900 hover:bg-rose-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              Delete
            </button>
            <button
              onClick={() => {
                setDeleteStatus(false);
              }}
              className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md font-medium text-black bg-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
